import * as React from "react";
import { Process, IStepConfig, StepType } from "../../../Shared/Process/Process/Process";
import { getQueryParameters } from "../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Urls } from "../../../Dashboard/Urls";
import { Spinner } from "../../../../react-core/Html/Spinner";
import { Contents } from "../../../Dashboard/Resoures/Contents";
import { Lightbox, LightboxType } from "../../../../react-core/Html/Components/Lightbox";
import { Navigator } from "../../../Shared/Wizards/Entities/Navigator";
import { wizardStepperName } from "../Resource/Content";
import { ServiceProvider } from "./NetworkWizard/ServiceProvider";
import { Validate } from "./NetworkWizard/Validate";
import { NetworkAction } from "../Actions/NetworkAction";
import { NetworkType } from "../../../../Wrap/Constants/Enums/Network/NetworkType";
import { NetworkWizardStore, NetworkStore } from "../Stores/Variable";
import { NetworkInstructionModel } from "../../../../Wrap/Models/Models/Network/NetworkInstructionModel";
import { Commission } from "../../Company/CompanyWizard/Components/CompanySetUpWizard/Commission/Commission";
import { NetworkDetails } from "./NetworkWizard/NetworkDetails";
import { BankAccountOwner } from "../../../../Wrap/Constants/Enums/Domain/BankAccountOwner";
import { InstructionStatus } from "../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { BaseComponent } from "../../../../react-core/Html/BaseComponent";
import { Confirmation } from "../../../Shared/Process/Process/Confirmation";
import { FormComponent } from "../../../../react-core/Html/FormComponent";
import { IndividualUserFunctionClient } from "../../../../Wrap/Api/User/IndividualUserFunction";
import { UserStore } from "../../../Dashboard/Stroes/Variable";

interface INetworkWizardState {
    data: NetworkInstructionModel;
    isLoading: boolean;
    errorMsg: string[];
    active: boolean;
    serviceProvider: any;
    isSubmitting: boolean;
    hasNetworkPermission: boolean;
}

interface INetworkWizardProps {}
export class NetworkWizard extends FormComponent<INetworkWizardProps, INetworkWizardState> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            isLoading: true,
            errorMsg: [],
            active: true,
            serviceProvider: [],
            isSubmitting: false,
            hasNetworkPermission: false,
        };
        this.subscribeToStore(NetworkWizardStore, () => this.onNetworkWizardChange());
        this.subscribeToStore(NetworkStore, () => this.onNetworkStoreChange());
    }

    child: any = {};

    componentDidMount() {
        const id = getQueryParameters()["id"];
        NetworkAction.getNetworkInstruction(id);
        this.checkNetworkPermission();
    }

    public checkNetworkPermission() {
        const FunctionName = "CanModifyNetworks";
        const clientId = UserStore.getUserInfo().ClientId;

        if (clientId !== undefined && clientId !== null) {
            const client = new IndividualUserFunctionClient();
            const promise = client.get(clientId, FunctionName);

            promise
                .onSuccess((data) => {
                    this.setState({ hasNetworkPermission: data });
                })
                .onError(() => {
                    this.setState({ hasNetworkPermission: false });
                });
        }
    }

    private onNetworkStoreChange() {
        const data = NetworkStore.getData();
        if (data) {
            this.setState({ serviceProvider: data.networks });
        }
    }

    private onNetworkWizardChange() {
        const data = NetworkWizardStore.getData();
        if (data) {
            const serviceProvider = NetworkStore.getData();
            if (!serviceProvider) {
                const query = {
                    NetworkType: NetworkType.ServiceProvider,
                    Max: 1000,
                    Min: 1,
                };
                NetworkAction.getNetwork(query);
            } else {
                this.setState({ serviceProvider: serviceProvider.networks });
            }
            this.setState({ isLoading: false, active: data.Status == InstructionStatus.Pending, data });
        }
    }

    private OnLeaveStepServiceProvider(isExit?: boolean): void {
        if (!this.state.active) {
            return isExit ? this.OnExit() : Navigator.navigateTo(Urls.get().ValidationNetworkWizard);
        }
        const isPass = this.child.serviceProvider.isValid();
        if (isPass) {
            NetworkAction.updateNetworkInstruction(this.state.data, () => {
                if (isExit) {
                    this.OnExit();
                } else {
                    Navigator.navigateToAndPreserveQueryParameters(Urls.get().ValidationNetworkWizard);
                }
            });
        }
    }

    private onStepNetworkLeave(isExit?: boolean) {
        if (!this.state.active) {
            return isExit
                ? this.OnExit()
                : Navigator.navigateToAndPreserveQueryParameters(Urls.get().ValuationNetworkWizard);
        }
        const isPass = this.child.network.isValid();
        if (isPass) {
            if (this.state.data.FaxNumber?.Country == null || this.state.data.FaxNumber.Country == 0) {
                this.state.data.FaxNumber = null;
            }
            if (this.state.data.PhoneNumber?.Country == null || this.state.data.PhoneNumber.Country == 0) {
                this.state.data.PhoneNumber = null;
            }
            NetworkAction.updateNetworkInstruction(this.state.data, () => {
                if (isExit) {
                    this.OnExit();
                } else {
                    Navigator.navigateToAndPreserveQueryParameters(Urls.get().ValuationNetworkWizard);
                }
            });
        }
    }

    private OnCommissionLeave(isExit?: boolean) {
        if (!this.state.active) {
            Navigator.navigateToAndPreserveQueryParameters(Urls.get().ValidationNetworkWizard, true);
            return;
        }
        const flag = this.child.commission.isValid();
        if (flag) {
            NetworkAction.updateNetworkInstruction(this.state.data, () => {
                if (isExit) {
                    this.OnExit();
                } else {
                    Navigator.navigateToAndPreserveQueryParameters(Urls.get().ValidationNetworkWizard, true);
                }
            });
        }
    }

    private OnExit() {
        Navigator.navigateTo(Urls.get().main.NetworkWizardSetup);
    }

    private onDataChange(changes) {
        const { data } = this.state;
        for (const key in changes) {
            data[key] = changes[key];
        }
        this.setState({ data });
        console.log("data: ", data, " change: ", changes);
    }

    private onSubmit(): void {
        const { data } = this.state;
        data.Status = InstructionStatus.Submitted;
        this.setState({ isSubmitting: true });

        NetworkAction.submit(data, () => this.setState({ active: false, isSubmitting: false }));
    }

    private onSave(currentStep?: number): void {
        const type = this.state.data.NetworkType;
        if (type == NetworkType.ServiceProvider && currentStep == 0) {
            this.OnLeaveStepServiceProvider(true);
        } else if (type == NetworkType.Network && currentStep == 0) {
            this.onStepNetworkLeave(true);
        } else if (type == NetworkType.Network && currentStep == 1) {
            this.OnCommissionLeave(true);
        } else {
            this.OnExit();
        }
    }

    private onCancel(): void {
        NetworkAction.deleteNetworkList([this.state.data.Id], this.OnExit);
    }

    render() {
        if (this.state.isLoading) {return <Spinner />;}
        const { data } = this.state;

        let stepsConfig: IStepConfig[] =
            data.NetworkType == NetworkType.ServiceProvider
                ? [
                      {
                          title: wizardStepperName.serviceProvider,
                          url: Urls.get().ServiceProviderNetworkWizard,
                          path: Contents.URLMap.networkServiceProvider,
                          onStepLeave: () => this.OnLeaveStepServiceProvider(),
                          component: (
                              <ServiceProvider
                                  isReview={!this.state.active || !this.state.hasNetworkPermission}
                                  onChange={(changes) => this.onDataChange(changes)}
                                  data={this.state.data}
                                  onRef={(ref) => (this.child.serviceProvider = ref)}
                              />
                          ),
                      },
                  ]
                : [
                      {
                          title: wizardStepperName.network,
                          url: Urls.get().NetworkDetailsWizard,
                          path: Contents.URLMap.networkDetail,
                          onStepLeave: () => this.onStepNetworkLeave(),
                          component: (
                              <NetworkDetails
                                  serviceProvider={this.state.serviceProvider}
                                  isReview={!this.state.active || !this.state.hasNetworkPermission}
                                  onChange={(changes) => this.onDataChange(changes)}
                                  data={this.state.data}
                                  onRef={(ref) => (this.child.network = ref)}
                              />
                          ),
                      },
                      {
                          title: wizardStepperName.valuation,
                          url: Urls.get().ValuationNetworkWizard,
                          path: Contents.URLMap.remunerationAndValuation,
                          onStepLeave: () => this.OnCommissionLeave(),
                          component: (
                              <Commission
                                  isReview={!this.state.active || !this.state.hasNetworkPermission}
                                  onChange={(changes) => this.onDataChange(changes)}
                                  data={this.state.data}
                                  onRef={(ref) => (this.child.commission = ref)}
                                  bankOwnerType={BankAccountOwner.Network}
                                  isNetWork={true}
                              />
                          ),
                      },
                  ];
        if (this.state.hasNetworkPermission) {
            stepsConfig = stepsConfig.concat([
                {
                    title: wizardStepperName.validationAndExcute,
                    url: Urls.get().ValidationNetworkWizard,
                    path: Contents.URLMap.validationAndExcute,
                    onSubmit: () => this.onSubmit(),
                    component: (
                        <Validate
                            onChange={(changes) => this.onDataChange(changes)}
                            data={this.state.data}
                            onRef={(ref) => (this.child.commission = ref)}
                        />
                    ),
                },
                {
                    title: wizardStepperName.confirmation,
                    url: Urls.get().ConfirmNetworkWizard,
                    path: Contents.URLMap.confirmation,
                    type: StepType.Confirmation,
                    component: (
                        <Confirmation
                            onExit={() => this.OnExit()}
                            successMessage={"We have successfully received your application for network setup"}
                            isLoading={this.state.isSubmitting}
                        />
                    ),
                },
            ]);
        }

        return (
            <>
                <Process
                    stepsConfig={stepsConfig}
                    onCancel={this.state.active ? () => this.onCancel() : null}
                    onSave={(currentStep) => this.onSave(currentStep)}
                    processTitle="Network wizard"
                    goBacktoFirst={true}
                    active={this.state.active}
                    isShowError={false}
                    errorMsg={[]}
                    onClearError={() => this.setState({ errorMsg: [] })}
                />
                {this.state.errorMsg.length > 0 && (
                    <Lightbox
                        show={this.state.errorMsg.length > 0}
                        title={"Alert"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ errorMsg: [] })}
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        {this.state.errorMsg.map((error, index) => {
                            return <p key={`error-${index}`}>{error}</p>;
                        })}
                        <button className="btn primary" onClick={() => this.setState({ errorMsg: [] })}>
                            OK
                        </button>
                    </Lightbox>
                )}
            </>
        );
    }
}
